import { LimitedRecipientCard } from "../../../../../pages/user/monthly-limits/limited-recipient-card/limited-recipient-card";
import { CustomerPageEmpty } from "../../../../../pages/user/monthly-limits/styled";
import BarekamText from "../../../../../pages/components/text";
import { Message, MessageSections } from "../../../../../pages/components/message/message";
import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Recipient } from "../../../../../pages/shared/models/user/recipient/recipient";
import { User } from "../../../../../pages/shared/models/user/user";
import recipientService from "../../../../../services/recipient.service";

const CustomerPersonalInfo = ({ customer }: { customer: User | undefined }) => {
    const [isReady, setIsReady] = useState<boolean>(false);
    const [limitedRecipients, setLimitedRecipients] = useState<Recipient[]>([]);

    useEffect(() => {
        recipientService.getRecipients({ relatedUser: customer?.userId })
            .then(response => {
                setLimitedRecipients(response.recipients.filter(recipient => !!recipient.monthlyLimit))
            })
            .then(() => {
                setIsReady(true);
            })
    }, []);

    if (isReady) {
        return (
            <Grid container>
                {limitedRecipients.map(recipient =>
                    <LimitedRecipientCard recipient={recipient}
                        key={recipient.recipientId} />
                )}

                {limitedRecipients.length
                    ? <></>
                    : <CustomerPageEmpty>
                        <BarekamText variant={"xxl"} align={"center"} bold opaque>
                            <Message messageKey={'no_monthly_limits'} sectionId={MessageSections.USER} />
                        </BarekamText>
                    </CustomerPageEmpty>
                }
            </Grid>
        )
    } else {
        return <></>
    }
};

export default CustomerPersonalInfo;
